import { create } from "apisauce";

// define the api
export const api = create({
  baseURL: document.location.origin,
});
